// extracted by mini-css-extract-plugin
module.exports = {"form":"Connect-module--form--2pNN0","errortext":"Connect-module--errortext--2uM1e","successtext":"Connect-module--successtext--3ooOf","body":"Connect-module--body--1Z-UJ"};